import { Dialog } from "@mui/material"
import { useCallback, useContext, useState } from "react"
import { AuthContext } from "../../../../../contexts/AuthContext"
import moment, { Moment } from "moment"
import useMobileScreen from "../../../../../lib/useMobileScreen"
import DialogContentSelecionarCliente from "../../../../../components/DialogContentSelecionarCliente/indext"
import { IDataPublicos } from "../../../../../types/api/geral/pesquisar-publicos"
import { defValueLoja, IDataLojas } from "../../../../../types/api/geral/pesquisar-lojas"
import CriarPedido from "./CriarPedido"
import { enqueueSnackbar } from "notistack"

export default function DialogCriarPedidoVenda({
    open,
    handleClose,
    onCreate,
    onFail
}: DialogCriarPedidoVendaProps) {

    const telaMobile = useMobileScreen();

    const { userPerfilComLoja } = useContext(AuthContext)

    const [modalContent, setModalContent] = useState<TModalContent>("selecionarCliente")
    const [values, setValues] = useState<IValue>({
        loja: userPerfilComLoja?.loja || defValueLoja,
        cliente: {
            tipo_publico: "",
            codigo_publico: "",
            nome_pessoa: "",
            tipo_pessoa: "",
            documento_pessoa: "",
            endereco: "",
            bairro: "",
            cep: "",
            cidade: {
                id: 0,
                nome: "",
                estado: ""
            },
            processo: [],
            telefone: "",
            email: "",
            limite_credito: "",
            limite_utilizado: "",
            limite_disponivel: "",
            situacao_financeira: "",
            ranking: "",
            comprador: "",
            selected_fazenda: null,
            fazendas: [],
            dia_vencimento_padrao: 20,
        },
        pedido: {
            produtos: [],
            subTotal: 0,
            descontos: 0,
            entrega: {
                formaEntrega: "Por conta da cooperativa",
                previsaoEntrega: moment(),
                freteEstimado: "0",
                observacoes: ""
            },
            pagamento: {
                condicaoPag: {
                    id: null,
                    loja_id: null,
                    nome: "",
                    parametros: {
                        maximo_parcelas: 0
                    },
                    taxa: 0
                },
                qtdParcelas: 0,
                possuiEntrada: false,
                valorEntrada: 0,
                dataEntrada: moment(),
                parcelas: []
            }
        }
    })

    //Funções Manipuladoras
    const handleConfirm = useCallback(() => {
        if (modalContent === "selecionarCliente") {
            setModalContent("criarPedido")
        }
    }, [modalContent])

    const handleBack = useCallback(() => {
        setModalContent("selecionarCliente")
    }, [])

    const handleChangeValues = useCallback((prop: "cliente" | "pedido", value: any) => {

        if (prop === "cliente" && value.situacao_financeira === "BLOQUEADO DEFINITIVO") {
            return enqueueSnackbar("Cliente com situação financeira BLOQUEADO DEFINITIVO. Não é possível criar pedido.", { variant: "error" })
        }

        setValues(prevState => ({
            ...prevState,
            [prop]: value
        }))
        handleConfirm()
    }, [handleConfirm])
    //

    return (
        <>

            {
                modalContent === "selecionarCliente" &&
                <Dialog
                    open={open}
                    fullWidth
                    fullScreen={telaMobile}
                    maxWidth={modalContent === "selecionarCliente" ? "sm" : "lg"}
                    scroll="body"
                    PaperProps={{
                        style: {
                            backgroundColor: '#f5f5f5'  // cinza claro
                        }
                    }}
                >
                    <DialogContentSelecionarCliente
                        {...{ handleClose }}
                        retornarFazendas
                        defaultValue={values.cliente}
                        onChange={(value) => handleChangeValues("cliente", value)}
                    />
                </Dialog>
            }


            {
                modalContent === "criarPedido" &&
                <CriarPedido
                    defaultValuePedido={values.pedido}
                    defaultValueCliente={values.cliente}
                    onBack={() => handleBack()}
                    onChange={(value: TPedido) => handleChangeValues("pedido", value)}
                    {...{ onCreate, onFail, handleClose }}
                />
            }
        </>
    )
}

interface DialogCriarPedidoVendaProps {
    open: boolean,
    handleClose: () => void,
    onCreate: (codigo: string) => void
    onFail: () => void
}

type TModalContent = "selecionarCliente" | "criarPedido"

interface IValue {
    loja: TLoja,
    cliente: IDataPublicos,
    pedido: TPedido
}

export type TLoja = IDataLojas

export type TClient = {
    cidade: string,
    codigo: string | null,
    cooperativa_id: number,
    documento: string,
    estado: string,
    limite_credito: string,
    limite_disponivel: string,
    limite_utilizado: string,
    nome: string,
    ranking: string,
    situacao_financeira: string,
    tipo: string,
    comprador: string,
    fazendaSelecionada: string | null
}

export type TPedido = {
    produtos: Array<TProduto>,
    subTotal: number,
    descontos: number,
    entrega: TEntrega,
    pagamento: TPagamento
}

export type TProduto = {
    id: string,
    estoque_atual: string,
    nome: string,
    preco: string,
    unidade_medida: string,
    quantidade?: number,
    desconto?: number,
    tipoDesconto?: "R$" | "%",
    setor: {
        id: string,
        nome: string,
    }
    parametros: {
        aceita_decimal: number,
        bloquear_nova_compra: number,
        maximo_parcelas: number,
        percentual_desconto_maximo: number,
        permite_desconto: number
    },
    departamento: {
        id: string,
        nome: string
    }
}

export type TEntrega = {
    formaEntrega: string,
    previsaoEntrega: Moment,
    freteEstimado: string,
    observacoes: string
}

export type TPagamento = {
    condicaoPag: TCondicaoPag,
    qtdParcelas: number,
    possuiEntrada: boolean,
    valorEntrada: number,
    dataEntrada: Moment,
    parcelas: TListaParcelas[]
}

export type TCondicaoPag = {
    id: number | null,
    loja_id: number | null,
    nome: string,
    parametros: {
        maximo_parcelas: number
    },
    taxa: number
}

export type TListaParcelas = {
    valor: number;
    vencimento: string;
}